import React from 'react';
import ReactDOM from 'react-dom';
import { Icon } from 'antd';

class SgiIcon extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);

        //初始化state
        this.state = {
		...this.state,
            inputprops: {
                type: "", // 图标类型
                spin: "", //是否有旋转动画
                style: {  },
            },
            loading: false
        };
    }

    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {对象工厂} objFct
     * @param {make类型} type
     */
    icon_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }
        //转换基础属性
        this.AddInputAttribute(moduleDesc, this.state.inputprops, this.state.tooltiProps, this.state.badgeProps);
    }

    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formItem
     * @param {属性} inputprops
     */
    AddInputAttribute(moduleDesc, inputprops, tooltiProps, badgeProps) {
        var type = moduleDesc.type;// 图标类型
        if (type) inputprops.type = type;

        var spin = moduleDesc.spin;//是否有旋转动画
        if (spin) inputprops.spin = spin;

        var fontSize = moduleDesc.fontSize;// 大小
        if (fontSize) inputprops.style.fontSize = fontSize;

        var color = moduleDesc.color;// 颜色
        if (color) inputprops.style.color = color;
    }

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }


    //渲染并返回一个虚拟DOM
    render = function () {

        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性
            this.icon_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }

        return (
            <Icon {...this.state.inputprops} />
        );
    }
}

export { SgiIcon };
export default SgiIcon;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiIcon.js